import { useNavigate } from "react-router-dom";

import { Box, Typography } from "@mui/material";
import Link from "@mui/material/Link";
import Tooltip from "@mui/material/Tooltip";

import { CampaignAnalyticsService } from "@analytics/index";

import { StatusesType } from "@hooks/useFilteredEmails";

import { EmailType } from "@interfaces/campaign.type";

interface ICardContactsProperties {
  activeSection: StatusesType;
  campaignId: string;
  emails: EmailType[];
  isLeadCard?: boolean;
  shouldShowNumbers?: boolean;
}

export default function CardContacts({
  activeSection,
  campaignId,
  emails,
  isLeadCard,
  shouldShowNumbers = true,
}: ICardContactsProperties) {
  const navigate = useNavigate();
  let section: keyof EmailType = "linkClicked";

  switch (activeSection) {
    case "clicked": {
      section = "linkClicked";
      break;
    }
    case "opened": {
      section = "opened";
      break;
    }
    case "responded": {
      section = "replyReceived";
      break;
    }
    default: {
      section = "opened";
    }
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        height: "124px",
        overflowY: "auto",
      }}
    >
      {emails
        .sort((a, b) => (a[section] > b[section] ? -1 : 1))
        .filter((email) => (isLeadCard ? email.status.lead : true))
        .map((email) => (
          <Box
            key={email.id}
            sx={{
              alignItems: "center",
              display: "flex",
              gap: 1,
              justifyContent: "space-between",
            }}
          >
            <Tooltip placement="bottom" title="View contact information">
              <Link
                onClick={() => {
                  navigate(
                    `/campaigns/${campaignId}/contacts?searchQuery=${email.email}&section=${isLeadCard ? "leads" : activeSection}`,
                  );
                }}
                sx={{
                  cursor: "pointer",
                }}
              >
                <b>{email.name} </b>
                {`<${email.email}>`}
              </Link>
            </Tooltip>
            {shouldShowNumbers && (
              <Typography fontWeight={600} variant="body2">
                {email[section]}
              </Typography>
            )}
          </Box>
        ))}
    </Box>
  );
}
